module.exports = __webpack_public_path__ + "static/img/p4.d4a9ed61.jpg";